// Die dimensions (width / T1 / T2 / CR) always show at least 2 decimals: 12 → "12.00", 6.5 → "6.50", 22.225 stays "22.225".
export const fmtDim = (v, blank = "-") => {
  if (v === null || v === undefined || v === "") return blank;
  const n = typeof v === "number" ? v : Number(String(v).trim());
  if (!Number.isFinite(n)) return String(v);
  const frac = (String(+n.toFixed(4)).split(".")[1] || "").length;
  return n.toFixed(Math.max(2, frac));
};

// Bar size of a WO row: "Ø 25.00" for a round (dia, no T1), "100.00 × 10.00" (× T2) for a flat.
export const fmtSize = (r, blank = "—") => {
  if (!r || r.section === null || r.section === undefined || r.section === "") return blank;
  const round = r.shape === "round" || !(parseFloat(r.t1) > 0);
  if (round) return `Ø ${fmtDim(r.section)}`;
  return `${fmtDim(r.section)} × ${fmtDim(r.t1)}${parseFloat(r.t2) > 0 ? ` × ${fmtDim(r.t2)}` : ""}`;
};
